export enum eCoverageType {
  LenderStandard = 'lender_standard', // standard == longForm
  LenderExtended = 'lender_extended',
  LenderExpanded = 'lender_expanded',
  LenderShortForm = 'lender_short_form',
  LenderTitleGuaranty = 'lender_title_guaranty',
  OwnerStandard = 'owner_standard',
  OwnerExtended = 'owner_extended',
  OwnerHomeowners = 'owner_homeowners',
  OwnerTitleGuaranty = 'owner_title_guaranty',
}

export const prettyCoverageTypes: Record<eCoverageType, string> = {
  [eCoverageType.LenderStandard]: 'Lender Standard',
  [eCoverageType.LenderExtended]: 'Lender Extended',
  [eCoverageType.LenderExpanded]: 'Lender Expanded',
  [eCoverageType.LenderShortForm]: 'Lender Short Form',
  [eCoverageType.LenderTitleGuaranty]: 'Lender Title Guaranty',
  [eCoverageType.OwnerStandard]: 'Owner Standard',
  [eCoverageType.OwnerExtended]: 'Owner Extended',
  [eCoverageType.OwnerHomeowners]: 'Owner Homeowners',
  [eCoverageType.OwnerTitleGuaranty]: 'Owner Title Guaranty',
};
